export default {
  title: {
    id: 'sav_platform_intro_title_missing_addresses',
    defaultMessage: 'Uh-oh! Return address missing',
  },
  description: {
    id: 'sav_platform_intro_description_missing_addresses',
    defaultMessage:
      "You haven't set up a return address for your account. With the release of our returns tracking feature, it is now mandatory to provide a return address as it will enable you to provide and receive tracking information for all returns activity, and will automatically notify the customer with delivery updates.",
  },
  openAddresses: {
    id: 'sav_platform_intro_lets_go_addresses',
    defaultMessage: 'Add an address',
  },
  close: {
    id: 'sav_platform_intro_close',
    defaultMessage: 'Close',
  },
}
